/**
 * Header section for the task list panel.
 *
 * @module tasksListHeader
 */
import TaskLinkIcon from "../../../../../svg/taskLinkIcon";
import TaskPlusIcon from "../../../../../svg/taskPlusIcon";

/**
 * Props for {@link TasksListHeader}.
 */
interface TasksListHeaderProps {
  onCreateTask: () => void;
  onLinkTask: () => void;
}

/**
 * Renders the title row and task action buttons.
 *
 * @param props - Action handlers for create/link buttons.
 * @returns Header UI for the left task-list panel.
 */
const TasksListHeader = ({
  onCreateTask,
  onLinkTask,
}: TasksListHeaderProps) => {
  return (
    <div className="flex items-center justify-between border-b border-primaryGray-14 px-4 py-3">
      <h3 className="text-base font-bold leading-6 text-[#0F0F0F]">Tasks</h3>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="flex h-7 w-7 items-center justify-center rounded border border-primaryGray-14 text-sm text-primaryGray-2"
          onClick={onCreateTask}
          aria-label="Create task"
        >
          <TaskPlusIcon />
        </button>
        <button
          type="button"
          className="flex h-7 w-7 items-center justify-center rounded border border-primaryGray-14 text-sm text-primaryGray-2"
          onClick={onLinkTask}
          aria-label="Link task"
        >
          <TaskLinkIcon className="h-[1.2rem] w-[1.2rem] shrink-0" />
        </button>
      </div>
    </div>
  );
};

export default TasksListHeader;
